var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "list_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#list_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5 21.6h3.333v-3.2H5v3.2ZM5 28h3.333v-3.2H5V28Zm0-12.8h3.333V12H5v3.2Zm6.667 6.4H35v-3.2H11.667v3.2Zm0 6.4H35v-3.2H11.667V28Zm0-16v3.2H35V12H11.667ZM5 21.6h3.333v-3.2H5v3.2ZM5 28h3.333v-3.2H5V28Zm0-12.8h3.333V12H5v3.2Zm6.667 6.4H35v-3.2H11.667v3.2Zm0 6.4H35v-3.2H11.667V28Zm0-16v3.2H35V12H11.667Z"
}))));
export default SvgList;